<template>
<DetailInfo class="satisfaction-survey-container" :btnList="btnList">
    <div v-if="hasSatisfactionSurveyAnswer" class="satisfaction-survey-content">
      <CollapseContent v-for="(questionnaire, index) in candidateSatisfactionSurveyInfo" :key="index" :title="questionnaire.name">
        <template #suffix>
          <div class="invitation-time-container">
            <span class="invitation-time-label">{{ $t(`${i18nPrefix}.label.invitationTime`) }}: </span>
            <span class="invitation-time-content">{{ questionnaire.invitation_time|formatDate }}</span>
          </div>
        </template>
        <Questionnaire :questionInfoList="questionnaire.questionnaire_answers"></Questionnaire>
      </CollapseContent>
    </div>
    <InviteSatisfactionQuestionnaire
      ref="inviteDialog"
      :candidateId="candidateId"
      :applicationList="applicationList"
      :jobId="jobId"
    />
  </DetailInfo>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import DetailInfo from './components/detailInfo.vue'
import CollapseContent from './components/collapseContent.vue'
import Questionnaire from './components/questionnaire.vue'
import InviteSatisfactionQuestionnaire from './dialog/inviteSatisfactionQuestionnaire.vue'
import { AsyncTask } from '@/utils/common'

export default {
  components: {
    DetailInfo,
    CollapseContent,
    Questionnaire,
    InviteSatisfactionQuestionnaire
  },
  props: {
    candidateBaseInfo: {
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      exportPdfStatus: {
        loading: false,
        task: null,
        finished: false
      },
      candidateSatisfactionSurveyInfo: null,
      hasSatisfactionSurveyPolicy: false,
      hasAgreePolicy: false
    }
  },
  computed: {
    applicationList () {
      return [{
        candidate: {
          id: this.candidateBaseInfo.id
        }
      }]
    },
    candidateId () {
      return this.candidateBaseInfo.id
    },
    jobId () {
      return this.candidateBaseInfo.job.id
    },
    hasSatisfactionSurveyAnswer () {
      return this.candidateSatisfactionSurveyInfo?.length > 0
    },
    btnList () {
      if (!this.hasAnyPermission('PERM_SATISFACTION_SURVEY_MANAGE') || this.candidateBaseInfo.is_agency_uploaded_and_hid) {
        return []
      }
      const inviteBtn = {
        label: this.$t(`${this.i18nPrefix}.btn.inviteSatisfactionSurvey`),
        onclick: this.onInviteBtnClick
      }
      if (this.hasSatisfactionSurveyPolicy && !this.hasAgreePolicy) {
        inviteBtn.disabled = true
        inviteBtn.tooltip = this.$t(`${this.i18nPrefix}.message.canNotInviteSatisfactionSurvey`)
      }
      const btnList = [inviteBtn]
      const vm = this
      if (this.hasSatisfactionSurveyAnswer) {
        btnList.push({
          label: this.$t(`${this.i18nPrefix}.btn.exportPDF`),
          onclick: this.onExportBtnClick,
          get loading () {
            const exportPdfStatus = vm.exportPdfStatus
            return exportPdfStatus?.task && !exportPdfStatus.finished
          }
        })
      }
      _.forEach(btnList, item => {
        Object.defineProperty(item, 'disabled', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled
          }
        })
        Object.defineProperty(item, 'tooltip', {
          enumerable: true,
          configurable: true,
          get () {
            return vm.isDisabled && vm.$t(`${vm.i18nPrefix}.message.disabledTip`)
          }
        })
      })
      return btnList
    }
  },
  created () {
    this.loadCandidateSatisfactionSurveyInfo()
  },
  methods: {
    ...mapActions('application', ['getExportCandidateProfilePDFTaskStatus', 'exportCandidateProfilePDF', 'getApplicationCandidateSurveyInfo']),
    async loadCandidateSatisfactionSurveyInfo () {
      const params = {
        job_id: this.jobId,
        candidate_id: this.candidateId,
        survey_type: 'satisfaction_survey'
      }
      const resp = await this.getApplicationCandidateSurveyInfo(params)
      if (resp) {
        this.candidateSatisfactionSurveyInfo = resp.answer
        this.hasSatisfactionSurveyPolicy = resp.has_satisfaction_policy
        this.hasAgreePolicy = resp.agreed_satisfaction_policy
      }
    },
    onInviteBtnClick () {
      this.$refs.inviteDialog.openDialog()
    },
    async onExportBtnClick () {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePDF({
        application_id: this.candidateBaseInfo.application_id,
        show_base_info: false,
        profile_type: '3'
      }), (taskId) => this.getExportCandidateProfilePDFTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/application/export/profile/?task_id=${taskId}&download=1`)
        exportPdfStatus.loading = false
        exportPdfStatus.finished = false
        exportPdfStatus.task = null
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.satisfaction-survey-container {
  .satisfaction-survey-content {
    max-width: 1125px;
    margin: 0 auto;

    .invitation-time-container {
      margin-left: auto;
    }
  }
}
</style>
